import React, { ChangeEvent } from 'react';

import { Box } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import GoalsImageSrc from '@common/assets/images/about-me/goals/goals_lg.jpg';

import {
	StyledGoalsCreateButton,
	StyledGoalsCreateStepsImg,
	StyledGoalsCreateStepsPaper,
} from '../styled';
import { StyledCreateStepsStep1TextField, StyledCreateStepsStep1TextWrap } from './styled';

interface PropsType {
	onClick: () => void;
	onSetGoal: (value: string) => void;
	value: string | null;
}

function StepsCreateStep1({ onClick, onSetGoal, value }: PropsType) {
	const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		onSetGoal(event.target.value);
	};

	return (
		<>
			<StyledGoalsCreateStepsPaper>
				<StyledGoalsCreateStepsImg alt="create goal step 1" src={GoalsImageSrc} />
				<StyledCreateStepsStep1TextWrap>
					<Box>
						<MediaTypography
							variant="h3"
							variants={{ sm: 'h4' }}
							textColor="secondary"
							sx={{ textAlign: 'center' }}
						>
							To achieve your main goal, we suggest breaking it down into separate sub-goals
						</MediaTypography>
						<MediaTypography
							variant="h3"
							variants={{ sm: 'h4' }}
							textColor="disabled"
							sx={{ textAlign: 'center' }}
						>
							(a maximum of 6 sub-goals)
						</MediaTypography>
					</Box>
					<StyledCreateStepsStep1TextField
						fullWidth
						label="Describe sub-goal"
						variant="standard"
						onChange={handleChange}
						value={value}
					/>
				</StyledCreateStepsStep1TextWrap>
			</StyledGoalsCreateStepsPaper>
			<StyledGoalsCreateButton variant="contained" onClick={onClick} disabled={!value}>
				Continuation
			</StyledGoalsCreateButton>
		</>
	);
}

export default StepsCreateStep1;
